import Text from 'components/Text.js'
import { View } from 'components/View.js'
import React from 'react'
import { useTheme } from 'modules/styles'

/**
 * @param children
 * @param isSelected
 * @param rest
 * @returns {Element}
 * @constructor
 */
export default function Chip ({
  children,
  isSelected,
  ...rest
}) {
  const theme = useTheme()
  return (
    <View
      bgc={isSelected ? 'black' : '#F6F6F6'}
      py='0.295rem'
      px='6px'
      style={{
        borderRadius: theme.borderRadius.button
      }}
      {...rest}
    >
      <Text
        c={isSelected ? 'white' : 'black'}
        fs='0.725em'
        fw='590'
      >
        {children}
      </Text>
    </View>
  )
}
